//contact.js
import React from "react"
import { Button, Form } from "react-bootstrap"
import PrimaryLayout from "../layouts/PrimaryLayout"
/* export default function Home() {
  return <div>Hello Gatsby</div>
} */

//creating arrow function and get rid of function keyword and curly braces
//you always need a wrapping element that returns all the nested elements
export default () => (
  <PrimaryLayout column="col-10">
      <div className="pt-5">
        <h1>Contact Us</h1>
        <Form>
          <Form.Group controlId="contactForm.Email">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" placeholder="Email..." />
          </Form.Group>
          <Form.Group controlId="contactForm.Subject">
            <Form.Label>Subject</Form.Label>
            <Form.Control type="text" placeholder="Subject..." />
          </Form.Group>
          <Form.Group controlId="contactForm.Message">
            <Form.Label>Message</Form.Label>
            <Form.Control as="textarea" rows="3" />
          </Form.Group>
          <Form.Group controlId="contactForm.Submit">
            <Button>Submit</Button>
          </Form.Group>
        </Form>
      </div>
  </PrimaryLayout>
)
